/* shto-three-forms: the blue bar under the cards follows the row as it is swiped (assets/shto-swipe.js moves the row).
   No row to swipe (desktop, or a screen wide enough for every card): no bar. */
(function () {
  function init(slider) {
    if (slider.shtoThreeForms) return;
    slider.shtoThreeForms = true;
    var track = slider.querySelector('[data-shto-three-forms-track]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max < 1) { slider.setAttribute('data-shto-three-forms-static', ''); return; }
      slider.removeAttribute('data-shto-three-forms-static');
      slider.style.setProperty('--shto-progress', Math.min(1, Math.max(0, track.scrollLeft / max)).toFixed(4));
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  function all() { document.querySelectorAll('[data-shto-three-forms]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
